'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = require('ifeis-isomorphic/lib/redux/actions/events');

var _setCurrentEvent = require('ifeis-isomorphic/lib/redux/actions/announce/setCurrentEvent');

var _setCurrentEvent2 = _interopRequireDefault(_setCurrentEvent);

var _announceMdl = require('./announce.mdl.scss');

var _announceMdl2 = _interopRequireDefault(_announceMdl);

var _mapStateToController = require('./mapStateToController');

var _mapStateToController2 = _interopRequireDefault(_mapStateToController);

var _ifeisIsomorphic = require('ifeis-isomorphic');

var _scores = require('ifeis-isomorphic/lib/utilities/scores');

var _getScoresheet = require('ifeis-isomorphic/lib/redux/actions/scores/getScoresheet');

var _getScoresheet2 = _interopRequireDefault(_getScoresheet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AnnounceController = function () {
  function AnnounceController($scope, $ngRedux, $mdMedia, feis, $mdDialog, $q, msgService, fAlert) {
    var _this = this;

    _classCallCheck(this, AnnounceController);

    this._svc = {
      $scope: $scope,
      $ngRedux: $ngRedux,
      $mdMedia: $mdMedia,
      feis: feis,
      $mdDialog: $mdDialog,
      $q: $q,
      msgService: msgService,
      fAlert: fAlert
    };

    this._svc.$ngRedux.dispatch((0, _events.getEventsInResultsQueue)(feis.id));

    this._svc.$ngRedux.connect(function (state) {
      return (0, _mapStateToController2.default)(feis.id, state);
    })(this);

    this._svc.$ngRedux.dispatch({ type: '/SOCKET_JOIN_ROOM', data: { room: 'EVENTS::' + feis.id, feisId: feis.id } });

    this._svc.$scope.$on('$destroy', function () {
      return _this._svc.$ngRedux.dispatch({ type: '/SOCKET_LEAVE_ROOM', data: { room: 'EVENTS::' + feis.id, feisId: feis.id } });
    });
  }

  _createClass(AnnounceController, [{
    key: 'toggleAnnounced',
    value: function toggleAnnounced(event, announceFlag, $event) {
      var _this2 = this;

      this._svc.$ngRedux.dispatch((0, _events.setAnnounced)(this._svc.feis.id, event.get('id'), announceFlag, event.get('version_id'))).then(function (response) {
        if (response && response.errors && response.errors.status === 417) {
          var _ref = response.errors.data && response.errors.data.errors[0],
              title = _ref.title,
              detail = _ref.detail;

          _this2._svc.fAlert($event, title, detail);
        }
      });
    }
  }, {
    key: 'showEventDetails',
    value: function showEventDetails(event) {
      var _this3 = this;

      this._svc.$q.all([this._svc.$ngRedux.dispatch((0, _setCurrentEvent2.default)(this._svc.feis.id, event.get('id'), true)), this._svc.$ngRedux.dispatch((0, _events.getAdjudicatorsForEvent)(this._svc.feis.id, event.get('id'))), event.get('medalRounds') ? this._svc.$ngRedux.dispatch((0, _events.getMedalRounds)(this._svc.feis.id, event.get('id'))) : Promise.resolve()]).then(function (s) {
        var genArray = function genArray(n) {
          return Array.apply(null, { length: n }).map(Number.call, Number);
        };
        if (event.get('rounds')) {
          _this3.scoresTemplate = genArray(event.get('rounds'));
        } else if (event.get('type') === 'C') {
          _this3.scoresTemplate = genArray(3);
        } else {
          _this3.scoresTemplate = genArray(1);
        }
        _this3.scoresTemplate = _this3.scoresTemplate.map(function (n) {
          return n = { round: n + 1 };
        });

        _this3.scores = new _ifeisIsomorphic.ScoreCalculator(event.toJS(), _this3.results.persons);

        _this3._svc.$q.all(_this3.results.currentEventWithAdjudicators.get('adjudicators').map(function (a) {
          return _this3._svc.$ngRedux.dispatch((0, _getScoresheet2.default)(_this3._svc.feis.id, _this3.results.currentEventWithAdjudicators.get('id'), a.get('id')));
        })).then(function (s) {
          return _this3.results.scoreSheets.map(function (scoreSheet) {
            return _this3.scores.addScoresheet(scoreSheet);
          });
        }, function (err) {
          return _this3.error(err);
        }).then(function (s) {
          _this3.scores.calculate();
          return _this3._svc.$mdDialog.show({
            template: require('./announce.dialog.html'),
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: _this3._svc.$mdMedia('md'),
            locals: {
              event: _this3.results.currentEventWithAdjudicators || _this3.results.currentEvent,
              participants: _this3.results.participants,
              eventMedalRounds: _this3.results.eventMedalRounds,
              on_complete: function on_complete(adjIdRound1, adjIdRound2, adjIdRound3) {
                adjIdRound1 && _this3.associateMedalRound(adjIdRound1, 1);
                adjIdRound2 && _this3.associateMedalRound(adjIdRound2, 2);
                adjIdRound3 && _this3.associateMedalRound(adjIdRound3, 3);
              },
              scores: _this3.scores,
              getDescription: _ifeisIsomorphic.getDescription
            },
            controller: 'AnnounceDialogController',
            controllerAs: 'announce'
          });
        });
      });
    }
  }, {
    key: 'associateMedalRound',
    value: function associateMedalRound(adjId, medalRound) {
      this._svc.$ngRedux.dispatch((0, _events.associateMedalRoundWithAdjudicator)(this._svc.feis.id, this.results.currentEventWithAdjudicators.get('id'), adjId, medalRound));
    }
  }, {
    key: 'getEventName',
    value: function getEventName(event) {
      if (event) {
        return (0, _ifeisIsomorphic.getDescription)(event.toJS());
      }
    }
  }]);

  return AnnounceController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.announce', ['ifeis.router-history']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.announce', {
    url: '/announce',
    template: require('./announce.mdl.html'),
    controller: AnnounceController,
    controllerAs: 'ann',
    ncyBreadcrumb: {
      label: 'Announce Awards',
      parent: 'feiseanna.one.admin.manager'
    }
  });
}).filter('notAnnounced', function () {
  return function (input) {
    if (input) {
      var notAnnouncedEvents = input.filter(function (event) {
        return !event.get('is_announced') || event.get('is_announced') === 0;
      });
      return notAnnouncedEvents;
    }
  };
}).filter('announced', function () {
  return function (input) {
    if (input) {
      var announcedEvents = input.filter(function (event) {
        return event.get('is_announced');
      });
      return announcedEvents;
    }
  };
}).controller('AnnounceDialogController', function ($scope, $mdDialog, event, participants, eventMedalRounds, on_complete, scores, getDescription) {
  var _this4 = this;

  this.event = event;
  $scope.roundValueInError = false;

  this.adjudicatorForMedalRound1 = event.get('adjudicators') && eventMedalRounds && event.get('adjudicators').find(function (adj) {
    return adj.get('id') === eventMedalRounds.getIn([1, 'adjudicator']);
  });
  this.adjudicatorForMedalRound2 = event.get('adjudicators') && eventMedalRounds && event.get('adjudicators').find(function (adj) {
    return adj.get('id') === eventMedalRounds.getIn([2, 'adjudicator']);
  });
  this.adjudicatorForMedalRound3 = event.get('adjudicators') && eventMedalRounds && event.get('adjudicators').find(function (adj) {
    return adj.get('id') === eventMedalRounds.getIn([3, 'adjudicator']);
  });

  $scope.placements = participants.filter(function (p) {
    return !!p.getIn(['reg', 'placed']);
  });

  $scope.adjudicatorsArrayForRounds = event.get('medalRounds') && event.get('adjudicators');

  this.scores = scores;
  this.adjudicators = $scope.adjudicatorsArrayForRounds && $scope.adjudicatorsArrayForRounds.toJS();
  this.scoresByAdjudicatorAndRound = {};

  function processScoresheet(scoresheet) {
    var round = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var adjId = scoresheet.scores[0].scores[0].adjudicator;
    var participantsScores = scoresheet.scores.map(function (participantScore) {
      var scoreObjectForRound = participantScore.scores.find(function (roundScore) {
        return roundScore.round === round;
      });
      var participantDetails = participants.find(function (p) {
        return p.get('competitor') === participantScore.competitor;
      });
      return {
        competitor: participantScore.competitor,
        value: scoreObjectForRound && scoreObjectForRound.value || undefined,
        name: participantDetails.get('fname') + ' ' + participantDetails.get('lname'),
        school: participantDetails.getIn(['school', 'name'])
      };
    });

    participantsScores.sort(function (a, b) {
      return b.value - a.value;
    });
    (0, _scores.getPlacementsForRound)(event.toJS(), participantsScores);

    return _defineProperty({}, adjId, participantsScores);
  }

  this.calculateScoresByAdjudicatorAndRound = function (round) {
    var initializedValue = this.scoresByAdjudicatorAndRound || {};
    this.scoresByAdjudicatorAndRound = this.scores.scoresheets.reduce(function (acc, scoresheet) {
      var processedScoresheet = processScoresheet(scoresheet, round);
      var adjId = Object.keys(processedScoresheet)[0];
      if (!acc[round]) {
        acc[round] = _defineProperty({}, adjId, processedScoresheet[adjId]);
      } else {
        acc[round][adjId] = processedScoresheet[adjId];
      }

      return acc;
    }, initializedValue);
  };
  for (var i = 1; i <= this.event.get('medalRounds'); i++) {
    this.calculateScoresByAdjudicatorAndRound(i);
  }

  $scope.cancel = function () {
    $mdDialog.cancel();
  };

  $scope.$on('$destroy', function () {
    on_complete(_this4.adjudicatorForMedalRound1 && _this4.adjudicatorForMedalRound1.get('id'), _this4.adjudicatorForMedalRound2 && _this4.adjudicatorForMedalRound2.get('id'), _this4.adjudicatorForMedalRound3 && _this4.adjudicatorForMedalRound3.get('id'));
  });

  $scope.getEventNameOnDialog = function (event) {
    if (event) {
      return getDescription(event.toJS());
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/announce/index.js
// module id = 539
// module chunks = 0